/**
 * Carte « Le cours » (SPEC FC14) : description Mindbody nettoyée, durée calculée, étoile étudiante,
 * bio du coach si elle existe. Aucune étiquette sans donnée Mindbody (pas d'intensité : § 2.4).
 */
import type { MindbodyClass } from 'types/class';
import { coachName, durationMinutes, isStudentClass, plainDescription } from '../lib/format';
import { Icon } from './Icon';

export function CourseCard({ cls }: { cls: MindbodyClass }) {
  const description = plainDescription(cls.ClassDescription?.Description);
  const minutes = durationMinutes(cls.StartDateTime, cls.EndDateTime);
  const student = isStudentClass(cls.ClassDescription?.Name);
  const bio = plainDescription(cls.Staff?.Bio);
  const coach = coachName(cls.Staff);

  if (!description && !minutes && !student && !bio) return null;

  return (
    <section className="mmv2-card mmv2-card--pad mmv2-course-card" aria-labelledby="mmv2-course-title">
      <h2 className="mmv2-kicker" id="mmv2-course-title">
        Le cours
      </h2>
      {description ? (
        <div className="mmv2-course-card__text">
          {description.split('\n').map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>
      ) : null}
      {minutes || student ? (
        <div className="mmv2-course-card__tags">
          {minutes ? <span className="mmv2-tag">{minutes} minutes</span> : null}
          {student ? (
            <span className="mmv2-tag mmv2-tag--action">
              Pack étudiant accepté <Icon name="star" size={11} stroke={2.2} />
            </span>
          ) : null}
        </div>
      ) : null}
      {bio ? (
        <p className="mmv2-small mmv2-muted mmv2-course-card__bio">
          <b>{coach}</b> — {bio}
        </p>
      ) : null}
    </section>
  );
}
